import { render } from "./ChartWordCloud.vue?vue&type=template&id=6e717cf4"
import script from "./ChartWordCloud.vue?vue&type=script&lang=js"
export * from "./ChartWordCloud.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@https+++registry.npmmirror.com+vue-loader+-+vue-loader-17.4.2.tgz_vue@3.2.13_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__